import pdfImg from "../../assets/pdf.png";
import docImg from "../../assets/docs.png";
import photoImg from "../../assets/image.png";
import icons from "../../constants/icons";
import "./styles.css";
import { Loading } from "../Loader";
import { Button } from "../Button";

const FilePreviewName = (props) => {
  let extSplit = props?.type?.split("/") || [];
  return (
    <div className="filter-preview-name">
      {props.isLoading ? (
        <>
          <Loading />{" "}
          <span className="text-disabled" style={{ marginLeft: "1rem" }}>
            Uploading...
          </span>
        </>
      ) : (
        <>
          <div className="file-preview-icon">
            <img
              src={
                extSplit.includes("pdf")
                  ? pdfImg
                  : extSplit.includes("doc")
                  ? docImg
                  : photoImg
              }
            />
          </div>
          <div className="file-preview-info">
            <p>{props.name}</p>
            {props.tmpURL &&
              (props?.tmpURL?.startsWith("http") ||
                props?.tmpURL?.startsWith("https")) && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Button
                    icon={icons.download}
                    className="btn-sm btn-transparent primary"
                    onPress={() => window.open(props.tmpURL, "_blank")}
                  />
                </div>
              )}
          </div>
          {/* <div className="file-preview-action">
            <div className="icon-container" onClick={props.handleRemoveFile}>
              <span
                className={`${process.env.REACT_APP_ICONS_TYPE} text-error`}
              >
                {icons.delete}
              </span>
            </div>
          </div> */}
        </>
      )}
    </div>
  );
};

export default FilePreviewName;
